<!-- <template>
  <div>
    <div alert show>Default Alert</div>
  </div>
</template> -->
<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12">
    <!-- <imessage/> -->
    <h1 class="top-title">Users and Status</h1>
    <!-- <div class="header2">
      <button class="btn btn-dark" type="button" @click="showAddProv">
        General Information
      </button>
      <button
        class="btn btn-dark"
        type="button"
        id="verifybtn"
        @click="ViewPrivacyConsent"
      >
        Privacy & Consent
      </button>
    </div> -->
    <div class="createNewUserSec col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <button
        class="btn btn-warning"
        type="button"
        id="createNwUserbtn"
        @click="showUserForm"
      >
        Create New User
      </button>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 addNurseSec">
      <add-user-form v-if="showingAdd" @close="CloseaddNurse" />

      <div class="container mt-4 data-tble">
        <h2 v-if="UserAccountData.length != 0">
          ({{ UserAccountData[0].accountnumber }}) - User Accounts
        </h2>

        <table id="dtTable" class="table table-bordered table-striped">
          <thead>
            <tr>
              <th></th>
              <th>Username</th>
              <th>Account Type</th>
              <th>Additional Roles</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Status</th>
              <th>Last Invite Sent</th>
              <th>Actions</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
  <!-- Same modal as in HomeGrid.vue; Change E-mail swaps the body in-place. -->
  <div
    v-if="pendingInviteModal"
    class="patient-invite-modal-overlay"
  >
    <div class="patient-invite-modal" role="dialog" aria-labelledby="account-invite-title">
      <p id="account-invite-title" class="patient-invite-modal__name">
        {{ pendingInviteDisplayName }}
      </p>
      <!-- Resend view: show current invite email + action buttons. -->
      <template v-if="!inviteChangeEmailMode">
        <p class="patient-invite-modal__email">{{ pendingInviteModal.email }}</p>
        <div class="patient-invite-modal__actions">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="inviteSending"
            @click="resendAccountInvitation"
          >
            {{ inviteSending ? "Sending…" : "Resend Invitation" }}
          </button>
          <!-- Middle action: switch into email-edit UI without closing the modal. -->
          <button
            type="button"
            class="btn btn-outline-secondary"
            :disabled="inviteSending"
            @click="openInviteChangeEmail"
          >
            Change E-mail
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            @click="closePendingInviteModal"
          >
            Cancel
          </button>
        </div>
      </template>
      <!-- Change-email view: prefilled input + uniqueness-gated Save. -->
      <template v-else>
        <label class="patient-invite-modal__email-label" for="pending-invite-change-email">
          E-mail
        </label>
        <input
          id="pending-invite-change-email"
          v-model="inviteChangeEmailValue"
          type="email"
          class="form-control patient-invite-modal__email-input"
          autocomplete="email"
          :disabled="inviteEmailSaving"
          @input="onInviteChangeEmailInput"
          @blur="validateInviteChangeEmail"
        />
        <p v-if="inviteChangeEmailError" class="patient-invite-modal__email-error">
          {{ inviteChangeEmailError }}
        </p>
        <div class="patient-invite-modal__actions">
          <!-- mousedown.prevent: avoid input blur disabling Save before the click lands. -->
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!canSaveInviteChangeEmail"
            @mousedown.prevent="saveInviteChangeEmail"
          >
            {{ inviteEmailSaving ? "Saving…" : "Save" }}
          </button>
          <!-- Cancel returns to resend view; does not close the whole modal. -->
          <button
            type="button"
            class="btn btn-secondary"
            :disabled="inviteEmailSaving"
            @click="cancelInviteChangeEmail"
          >
            Cancel
          </button>
        </div>
      </template>
    </div>
  </div>
  <!-- Reveals unique_ID for a row without dedicating a table column. -->
  <div
    v-if="userIdReveal"
    class="patient-invite-modal-overlay"
    @click.self="userIdReveal = null"
  >
    <div class="patient-invite-modal" role="dialog" aria-labelledby="user-id-reveal-title">
      <p id="user-id-reveal-title" class="patient-invite-modal__name">User ID</p>
      <p class="patient-invite-modal__email user-id-reveal-value">{{ userIdReveal }}</p>
      <div class="patient-invite-modal__actions">
        <button type="button" class="btn btn-secondary" @click="userIdReveal = null">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { register, isUserExist, isEmailExist } from "@/api/userApi";
import { post } from "@/store/modules/fsm/index";
import us from "us";
import {
  RequestRegistration,
  RegistrationSuccess,
  RegistrationFailure,
  Continue,
} from "@/store/modules/fsm/messages";
import FormError from "@/components/includes/form/FormError";
import { mask } from "vue-the-mask";
import { CURR_API, OTHER_API } from "@/constants/apis";
import $ from "jquery";
import DataTable from "datatables.net-dt";
//add datatables
// import 'datatables.net-dt/js/dataTables.dataTables'
//import 'datatables.net-dt/css/jquery.dataTables.min.css';
//import 'datatables.net-dt/css/jquery.dataTables.css';
import axios from "axios";
import VALIDATION_ERRORS from "@/data/validationErrors";
import genders from "@/data/genders";
import titles from "@/data/titles";
import suffixes from "@/data/suffixes";
import { isNpiExist } from "../../../api/userApi";
import { refusalMessage } from "@/api/refusals";
import { isFileUid } from "@/utils/fileUrl";
import { buildUploadNurseFileForm } from "@/utils/credentialUploadForm";
import { h } from "vue";
import { usePrivilegesStore } from "@/stores/privileges";
import { PRIVILEGES } from "@/constants/privileges";
import AddUserForm from "@/components/private-layouts/welcome/AddUserForm.vue";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import { accountStatusCell } from "@/utils/pendingAccountStatus";
import {
  accountActionCell,
  accountLifecycleConfirmation,
  accountLifecycleRefusal,
  runAccountLifecycleAction,
} from "@/utils/accountLifecycle";
import { useSessionStore } from "@/stores/session";

//import dataTasbles
// import "https://cdn.datatables.net/1.13.7/css/jquery.dataTables.min.css";

export default {
  name: "MyAccount",
  components: {
    "form-error": FormError,
    AddUserForm,
  },
  data() {
    return {
      states: us.states,
      genders,
      showingAdd: false,
      newmessage: "false",
      // isprocessing: "false",
      filemessage: "",
      UserAccountData: [],
      msgData: [],
      allProvs: null, // List of providers already saved for patient
      firstName: "",
      npiSearch: "", // Primary physician search textfield value
      searchedNpis: null, // List of physicians retrieved via npiSearch
      searchedAddresses: null, // List of addresses associated with chosen physician
      editedProv: null, // Provider that is being edited
      textingProv: null,
      txtMsg: "",
      txtPhone: "",
      addedProv: null, // Provider that new account is being made for
      requiredAr: [], //Arry that handles the required fields
      npisAdded: [], // List of npis added for group
      newGroupProvs: [],
      newGroupEmails: [],
      grouplist: [],
      groupNumber: [],
      featAr: [],
      // Pending-invite modal (same pattern as HomeGrid Pending button).
      pendingInviteModal: null,
      inviteSending: false,
      // Nested Change E-mail UI inside the resend modal.
      inviteChangeEmailMode: false,
      inviteChangeEmailValue: "",
      inviteChangeEmailError: "",
      inviteEmailChecking: false,
      inviteEmailSaving: false,
      // Clicking the ID icon in column 0 sets this to unique_ID.
      userIdReveal: null,
      // Who may deactivate and reactivate (Trello 0LGomfTd), read once the
      // privileges have loaded; the Actions column shows only what the
      // viewer may do, and never on their own row.
      accountActionRights: { canDeactivate: false, canReactivate: false, selfId: null },
      accountActionBusy: false,
      form: {
        isLoggedIn: false,
        noValidation: false,
        admin: true,
        id: null,
        accountType: "",
        npi: "",
        externid: "",
        externid2: "",
        first: "",
        last: "",
        login: "",
        password: "PACMNY_Reg1!",
        password2: "PACMNY_Reg1!",
        enrollmentId: null,
        dob: "1970-01-01",
        email: "",
        permission: "",
        gender: null,
        addr: "",
        city: "",
        state: "",
        zip: "",
        hascertificate:"",
        certificateValue:"",
        primaryPhoneType: null,
        primaryPhone: null,
        ssn: "",
        pref: "Email", 
        licenseNum: "",
        licenseSt: "",
        isHomeHealthAid:"",
        actiontaken:"",
        // insuranceCompany: "",
        // insuranceStart: "",
        // insuranceEnd: "",
        // perIncidentAmnt: 0,
        // annualAggAmnt: 0
      },
      /*msgDate:"06-10-2024",
     msSender:"Kevin Jones",
     alertmsg:"Anything about anything",*/
      formErrors: {},
      nwform: {}, //List of Phone numbers
      // patientContacts:null,            //patient contats
      // npi: "",                      // NPI of chosen physician
      // npiAddress: "",               // Address of chosen physician
      // npiPhone: "",                 // Phone number of chosen physician
      // npiFax: "",                   // Fax number of chosen physician
    };
  },
  async mounted() {
    // Check if the user has the necessary privilege to view the Users and Status page
    // Otherwise, redirect to the welcome page
    const privStore = usePrivilegesStore();
    await privStore.ensureLoaded();
    if (!privStore.effectiveGranted(PRIVILEGES.MY_ORG_VIEW)) {
      this.$router.replace("/welcome");
      return;
    }
    this.accountActionRights = {
      canDeactivate: !!privStore.effectiveGranted(PRIVILEGES.DEACTIVATE_USERS),
      canReactivate: !!privStore.effectiveGranted(PRIVILEGES.REACTIVATE_USERS),
      selfId: useSessionStore().me?.id ?? null,
    };
    // this.loadProviders()
    // console.log(this.allProvs)
    //this.addProviders();
    this.getAllAccountusers();
    // this.FetchMessages();
    const self = this;
    this.newmessage = true;
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
      isLoggedIn: "isLoggedIn",
    }),
    // Retrieves the display name of the user to be invited
    pendingInviteDisplayName() {
      const u = this.pendingInviteModal;
      if (!u) return "";
      return `${u.first_name || ""} ${u.lastname || ""}`.trim() || "User";
    },
    // Save enabled when email looks valid; uniqueness is re-checked inside save (not here).
    canSaveInviteChangeEmail() {
      const next = String(this.inviteChangeEmailValue || "").trim();
      // Do not gate on inviteEmailChecking — blur checks would disable Save mid-click.
      if (!next || this.inviteEmailSaving) return false;
      if (this.inviteChangeEmailError) return false;
      return this.isValidInviteEmailFormat(next);
    },
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
    relationships: function () {
      return this.allData.relationDescriptions;
    },
    phoneTypes: function () {
      return this.allData.phoneTypes;
    },
    isNurse: function () {
      return (
        this.form.accountType === "Registered Nurse" ||
        this.form.accountType === "Licensed Practical Nurse"
      );
    },
    fileprocessing: function () {
      return this.isprocessing === "true";
    },
    hasInsurance: function () {
      return (
        this.form.accountType === "Registered Nurse" ||
        this.form.accountType === "Licensed Practical Nurse" ||
        this.form.accountType === "Provider"
      );
    },
    self: function () {
      return this;
    },
  },
  methods: {
    setAidValue(accntType)
    {
      if(accntType=="Home Health Aid")
      {
        this.isHomeHealthAid = accntType;
      }
      else{
        this.isHomeHealthAid ="";
      }
      
    },
    // Not bound: this template has no #nursefile input and nothing calls
    // sendFile. Kept repaired so a future control gets a working upload.
    // pdftype is misc, the endpoint default (plan 7.1): the uid is a Documents
    // page row, not a license slot.
    async sendFile() {
      let formdata;
      try {
        formdata = buildUploadNurseFileForm({
          file: $("#nursefile")[0]?.files?.[0],
          pdftype: "misc",
          accountnumber: this.allData.patient.externId2,
          subaccnt: this.allData.patient.externId,
        });
      } catch (e) {
        alert("File upload wasn't successful, please try again");
        return;
      }
      this.isprocessing = "true";
      try {
        // No headers option: the browser writes the multipart boundary.
        const res = await axios.post(CURR_API + "/tswebhook.php", formdata);
        this.isprocessing = "false";
        if (isFileUid(res.data?.file_uid)) {
          this.nwform.file_uid = res.data.file_uid;
          alert("File upload Successful");
        } else {
          alert(refusalMessage(res.data) || "File upload wasn't successful, please try again");
        }
      } catch (err) {
        this.isprocessing = "false";
        console.log(err);
        alert(refusalMessage(err?.response?.data) || "System error, Please try again or contact the system Administrator for assistance.");
      }
    },
    /* async FetchMessages()
     {
            let content = {
                Messages: {
                    API_Meth:"FetchMessages",
                    accountnumber:this.allData.patient.externId2,
                    subaccountnumber:this.allData.patient.externId
                }
            }
            await axios
                .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                })
                .then((res) => {
                    console.log(res);
                    if (res.data) {
                      this.msgData = res.data.records;
                      console.log(this.msgData, res.data.records)
          //enable the bottun again
          var table2 =  $('#dtTable2').DataTable( {
                        data:this.msgData,
                        select:true,
                        columns: [
                            { item: 'accntid', render : function ( data, type, row, meta ) {
                              console.log(data);
                              console.log(type);
                              return type == 'display'  ?
                               '<a href="#deleteMsg" class="dgridlink" action="delete" id="'+ data +'" @click=\'TableAlert(data,type,row,meta)\'><img src=\'https://cdn-icons-png.flaticon.com/512/1214/1214428.png\' width=\'30\' height=\'30\'></i></a><a href="#viewMsg" class="dgviewmsglink2" action="view" id="'+ data +'"><img src=\'https://www.iconpacks.net/icons/1/free-mail-icon-142-thumb.png\' width=\'40\' height=\'40\'/></a>' :
                                data;
                              
                              
                            }},
                            { data: 'msgDate'},
                            { data: 'pt_name' },
                            { data: 'message'},
                            { data: 'msgStatus' },
                            /*{ data: 'account_type' },
                            { data: 'user_email' },
                            { data: 'user_Fname'},
                            { data: 'user_Lname'},
                            { data: 'address' }
                            { data: 'user_phone'}
                           
                           
                          ],
                          "drawCallback": function( settings ) {
                        
                            $("#closebtn").on( 'click', function (e) {
                            console.log("Go Get the values");
                            alert("Hi");
                           $(".show-msg").css("display","none");
                          this.newmessage=false;
                           
                          
                        });*/

    /* $("body").on("click",".dgviewmsglink2",function(e,type,indexes) {
                          e.preventDefault();
                          
                        
                          //find the ID
                          let bID = $(this).attr("action");
                          console.log(bID);
                          var rows = table2.rows($(this).parent("td")).data();
                           // var tarr = table.rows($(this)).data().toArray();
                           // console.log(tarr);
                            //console.log( 'There are'+ rows[0].user_Fname+" "+rows[0].user_Lname +" "+rows[0].username+" "+' row(s) of data in this table' );
                             console.log(rows);
                            this.msgDate = rows[0].msgDate;
                             this.msSender = rows[0].pt_name;
                             this.alertmsg = rows[0].message;
                            // Vue.set(this.msgDate,rows[0].msgDate);
                             console.log(this.msgDate);
                             console.log(this.msSender);
                             alert(this.msSender +" "+this.alertmsg);
                             $(".show-msg").css("display","block");
                           // this.newmessage=false;
                           // alert(this.newmessage);
                             
                            

                         });  

                    
                        }
                      } );

                    } else {
                        this.msgData = null;
                    }
                });*/
    /*},*/
    async ResetAccountUsers() {
      let content = {
        Account: {
          accountnumber: this.allData.patient.externId2,
          API_Meth: "GetAccountUsers",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let jdata = res.data;
          console.log(jdata);
          //of the table should be there and now we just need to lcoated it and reset the data
        })
        .catch((err) => {
          console.log(err);
          alert(err.message);
        });
    },
    async getAllAccountusers() {
      let content = {
        Account: {
          accountnumber: this.allData.patient.externId2,
          API_Meth: "GetAccountUsers",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          const vm = this;
          console.log(res);
          let jdata = res.data;
          console.log(res.data);
          // this.premInfo = [];
          // this.userpremInfo=[];
          // console.log(jdata);
          // The same person can hold more than one account_user row (e.g. an
          // org Administrator who is also a Provider/Nurse) - each role is a
          // genuinely separate row here, but with nothing connecting them
          // they read as two unrelated people who happen to share a name.
          // Group by email and attach the sibling role(s) to each row so the
          // table can surface "this is the same person" without collapsing
          // the two records into one (both unique_IDs stay independently
          // clickable/editable).
          const rowsByEmail = {};
          (jdata.data || []).forEach((r) => {
            const key = (r.user_email || "").trim().toLowerCase();
            if (!key) return;
            if (!rowsByEmail[key]) rowsByEmail[key] = [];
            rowsByEmail[key].push(r);
          });
          (jdata.data || []).forEach((r) => {
            const key = (r.user_email || "").trim().toLowerCase();
            const siblings = key ? rowsByEmail[key] : [];
            r.linkedRoles = siblings
              .filter((s) => s.unique_ID !== r.unique_ID)
              .map((s) => s.account_type)
              .filter(Boolean)
              .join(", ");
          });
          this.UserAccountData = jdata.data;
          //enable the bottun again
          // Destroys the existing DataTable and creates a new one
          // Resolves 'Cannot reinitialise DataTable' issue when opening form/adding user
          if ($.fn.DataTable.isDataTable("#dtTable")) {
            $("#dtTable").DataTable().clear().destroy();
          }
          var table = $("#dtTable").DataTable({
            data: this.UserAccountData,
            select: true,
            columns: [
              {
                data: null,
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                  if (type !== "display") return "";
                  const uid = String(row.unique_ID || "").replace(/"/g, "&quot;");
                  return (
                    '<a href="#" class="dgridlink-userid" title="Show User ID" data-unique-id="' +
                    uid +
                    '">' +
                    '<img src="https://cdn-icons-png.flaticon.com/512/1077/1077114.png" width="28" height="28" alt="User ID"/></a>'
                  );
                },
              },
              { data: "username" },
              { data: "account_type" },
              {
                data: "linkedRoles",
                render: function (data, type) {
                  if (type !== "display") return data;
                  if (!data) return '<span class="linked-roles-none">&mdash;</span>';
                  return (
                    '<span class="linked-roles-badge" title="Same person, also has this role">Also: ' +
                    data +
                    "</span>"
                  );
                },
              },
              { data: "user_email" },
              { data: "user_Fname" },
              { data: "user_Lname" },
              // Displays the account status per the user's account_status field;
              // Pending and Expired open the Resend Invitation modal.
              {
                data: "account_status",
                render: accountStatusCell,
              },
              // Sortable last invite timestamp (ISO/MySQL datetime sorts as string).
              {
                data: "invite_sent_at",
                defaultContent: "",
                render: function (data, type) {
                  const raw = data == null ? "" : String(data).trim();
                  // Empty timestamps sort oldest so "desc" keeps blanks at the bottom.
                  if (type === "sort" || type === "type") {
                    return raw || "0000-00-00 00:00:00";
                  }
                  if (!raw) return '<span class="linked-roles-none">&mdash;</span>';
                  // Server NOW() is UTC; treat naive MySQL DATETIME as UTC so toLocaleString is local.
                  let iso = raw.replace(" ", "T");
                  if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso)) {
                    iso += "Z";
                  }
                  const parsed = new Date(iso);
                  if (Number.isNaN(parsed.getTime())) return raw;
                  return parsed.toLocaleString();
                },
              },
              // Deactivate / Reactivate (accountLifecycle.js), for the
              // viewer's rights; main's Delete is not carried, the person
              // is kept and their sign-in taken instead.
              {
                data: null,
                orderable: false,
                searchable: false,
                defaultContent: "",
                render: function (data, type, row) {
                  if (type !== "display") return "";
                  return accountActionCell(row, vm.accountActionRights);
                },
              },
            ],
            order: [[8, "desc"]],
            createdRow: function (row, data) {
              if (data.linkedRoles) {
                $(row).addClass("linked-account-row");
              }
            },
          });

          // Responsible for opening the modal to resend an account invitation
          $("body")
            .off("click", ".account-status-pending-link")
            .on("click", ".account-status-pending-link", function (e) {
              e.preventDefault();
              const rows = table.rows($(this).closest("tr")).data();
              if (!rows || !rows.length) return;
              vm.openPendingInviteModal(rows[0]);
            });

          $("body")
            .off("click", ".account-deactivate-link")
            .on("click", ".account-deactivate-link", function (e) {
              e.preventDefault();
              const rows = table.rows($(this).closest("tr")).data();
              if (!rows || !rows.length) return;
              vm.changeAccountLifecycle(rows[0], "deactivate");
            });
          $("body")
            .off("click", ".account-reactivate-link")
            .on("click", ".account-reactivate-link", function (e) {
              e.preventDefault();
              const rows = table.rows($(this).closest("tr")).data();
              if (!rows || !rows.length) return;
              vm.changeAccountLifecycle(rows[0], "reactivate");
            });

          // User ID icon in the actions column.
          $("body")
            .off("click", ".dgridlink-userid")
            .on("click", ".dgridlink-userid", function (e) {
              e.preventDefault();
              const uid = $(this).attr("data-unique-id") || "";
              vm.userIdReveal = uid || null;
            });

          //trying something here
          /*$('#dtTable').dataTable().yadcf([
                        //{column_number : 0},
                        //{column_number : 0},
                       // {column_number : 1},
                       // {column_number : 2},
                        {column_number : 2,  filter_container_id: "dtTable_filter",filter_default_label:"Provider"}
                        //{column_number : 2, data: ["Yes", "No"], filter_default_label: "Select Yes/No"},
                       // {column_number : 3, text_data_delimiter: ",", filter_type: "auto_complete"},
                       // {column_number : 4, column_data_type: "html", html_data_type: "text", filter_default_label: "Select tag"}
                        ]);*/
          if (jdata.data.status == "Successful") {
            //now set take the payload data object and set it to the Global variable/array

            console.log(this.UserAccountData);
          } else if (jdata.data.status == "No Records Found") {
            console.log("No Data Found");
            console.log(jdata.data.errors);
            alert("No Users found for this account");
          }
        })
        .catch((err) => {
          console.log(err);
          alert(err.message);
        });
    },
    // Deactivate or reactivate one person (Trello 0LGomfTd), after saying
    // what it does and does not undo, then reload the table so the row shows
    // its new status. The API's refusals (yourself, the last administrator,
    // not deactivated) are shown in words.
    async changeAccountLifecycle(row, action) {
      if (this.accountActionBusy || !row) return;
      const name = `${row.user_Fname || ""} ${row.user_Lname || ""}`.trim() || row.username || "this user";
      if (!window.confirm(accountLifecycleConfirmation(action, row, name))) return;
      this.accountActionBusy = true;
      try {
        await runAccountLifecycleAction(action, row.unique_ID);
        alert(action === "reactivate" ? `${name} can sign in again.` : `${name} can no longer sign in.`);
        await this.getAllAccountusers();
      } catch (err) {
        alert(accountLifecycleRefusal(err));
      } finally {
        this.accountActionBusy = false;
      }
    },
    // Opens the modal to resend an account invitation
    openPendingInviteModal(row) {
      const email = row?.user_email;
      if (!email) {
        alert("This user does not have an email address on file.");
        return;
      }
      // Sets the modal data
      this.pendingInviteModal = {
        unique_ID: String(row.unique_ID || "").trim(),
        account_type: row.account_type || "",
        first_name: row.user_Fname || "",
        lastname: row.user_Lname || "",
        email,
      };
      // Reset nested Change E-mail state whenever the modal opens.
      this.inviteChangeEmailMode = false;
      this.inviteChangeEmailValue = "";
      this.inviteChangeEmailError = "";
      this.inviteEmailChecking = false;
      this.inviteEmailSaving = false;
      // Enables the resend button
      this.inviteSending = false;
    },
    closePendingInviteModal() {
      this.pendingInviteModal = null;
      this.inviteSending = false;
      this.inviteChangeEmailMode = false;
      this.inviteChangeEmailValue = "";
      this.inviteChangeEmailError = "";
      this.inviteEmailChecking = false;
      this.inviteEmailSaving = false;
    },
    // Enter Change E-mail mode with the current invite address prefilled.
    openInviteChangeEmail() {
      if (!this.pendingInviteModal) return;
      this.inviteChangeEmailValue = String(this.pendingInviteModal.email || "").trim();
      this.inviteChangeEmailError = "";
      this.inviteEmailChecking = false;
      this.inviteChangeEmailMode = true;
    },
    // Leave Change E-mail mode but keep the resend modal open.
    cancelInviteChangeEmail() {
      this.inviteChangeEmailMode = false;
      this.inviteChangeEmailValue = "";
      this.inviteChangeEmailError = "";
      this.inviteEmailChecking = false;
    },
    isValidInviteEmailFormat(email) {
      return /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(String(email || "").trim());
    },
    // Clear stale uniqueness errors while typing; re-check on blur.
    onInviteChangeEmailInput() {
      this.inviteChangeEmailError = "";
    },
    // Check if the email is valid and if it exists in the database
    async validateInviteChangeEmail() {
      const next = String(this.inviteChangeEmailValue || "").trim();
      this.inviteChangeEmailValue = next;
      this.inviteChangeEmailError = "";
      if (!next) {
        this.inviteChangeEmailError = "E-mail is required";
        return;
      }
      if (!this.isValidInviteEmailFormat(next)) {
        this.inviteChangeEmailError = VALIDATION_ERRORS.EMAIL_INVALID;
        return;
      }
      // Same address as current invite: treat as unique to this user (no Postgres hit).
      const current = String(this.pendingInviteModal?.email || "").trim();
      if (next.toLowerCase() === current.toLowerCase()) {
        return;
      }
      this.inviteEmailChecking = true;
      try {
        // Existing sessionless uniqueness check against LA_user.ZV_user_email.
        const exists = await isEmailExist(next);
        if (exists) {
          this.inviteChangeEmailError = VALIDATION_ERRORS.EMAIL_EXISTS;
        }
      } catch (err) {
        this.inviteChangeEmailError = String(err?.message || err || "Unable to check e-mail.");
      } finally {
        this.inviteEmailChecking = false;
      }
    },
    // Save the pending invitation's address (one write, PATCH /users/{id}/invitation), then return to the resend view with it.
    async saveInviteChangeEmail() {
      const user = this.pendingInviteModal;
      // Ignore repeat clicks while a save is already running.
      if (!user || this.inviteEmailSaving) return;

      // Fresh uniqueness/format check; proceed only when this pass clears.
      await this.validateInviteChangeEmail();
      if (this.inviteChangeEmailError) return;

      const next = String(this.inviteChangeEmailValue || "").trim();
      if (!next || !this.isValidInviteEmailFormat(next)) return;

      const accountnumber = this.allData?.patient?.externId2;
      const uniqueNine = String(user.unique_ID || "").trim();
      if (!accountnumber || !uniqueNine) {
        alert("Missing account or user identifier.");
        return;
      }

      // Unchanged: just close the editor and keep showing the same email.
      if (next.toLowerCase() === String(user.email || "").trim().toLowerCase()) {
        this.cancelInviteChangeEmail();
        return;
      }

      this.inviteEmailSaving = true;
      try {
        // One write: the pending invitation's address (PATCH
        // /users/{id}/invitation). Main also wrote Postgres first through
        // updateEmail(); on the port that is PATCH /users/{id}/credentials, a
        // credential change for an active account under its own permission,
        // which ran ahead of — and around — the invitation route's own rules:
        // only a Pending or Expired account, and a 409 for an address already
        // in use (ACC-12). The invitation route writes the sign-in address too.
        const mysqlRes = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Account: {
              API_Meth: "UpdatePendingAccountEmail",
              accountnumber,
              uniqueNine,
              email: next,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (mysqlRes?.data?.status !== "200" && mysqlRes?.data?.message !== "Updated") {
          throw new Error(
            mysqlRes?.data?.message || "Unable to update e-mail in organization records."
          );
        }
        // Reflect new address on the open resend modal and refresh the users table.
        this.pendingInviteModal = { ...user, email: next };
        this.cancelInviteChangeEmail();
        this.getAllAccountusers();
      } catch (err) {
        alert(err?.message || err || "Could not update e-mail.");
      } finally {
        this.inviteEmailSaving = false;
      }
    },
    // Endpoints to resend an account invitation
    async resendAccountInvitation() {
      const user = this.pendingInviteModal;
      if (!user) return;

      const accountnumber = this.allData?.patient?.externId2;
      const uniqueNine = String(user.unique_ID || "").trim();
      if (!accountnumber || !uniqueNine) {
        alert("Missing account or user identifier.");
        return;
      }

      this.inviteSending = true;
      try {
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Account: {
              API_Meth: "SendNewSubAccountEmail",
              accountnumber,
              uniquenine: uniqueNine,
              accounttype: user.account_type || "",
              accountholder: this.pendingInviteDisplayName,
              usertoemail: user.email,
              firstname: user.first_name || "",
              lastname: user.lastname || "",
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (res?.data?.status === "Successfull") {
          this.closePendingInviteModal();
          // Reload so Last Invite Sent reflects the stamp from QueSubEmailTemplate.
          this.getAllAccountusers();
          if (this.$swal) {
            this.$swal({
              type: "success",
              title: "Invitation sent",
              text: "The verification email has been resent.",
            });
          } else {
            alert("The verification email has been resent.");
          }
        } else {
          const msg =
            res?.data?.message ||
            "Could not resend the verification email. Please try again or contact an administrator.";
          alert(msg);
        }
      } catch (err) {
        alert(err?.message || "Could not resend the verification email.");
      } finally {
        this.inviteSending = false;
      }
    },

    ViewPrivacyConsent(event) {
      event.preventDefault();
      alert("show Privacy Alert");
    },
    showUserForm() {
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.CREATE_ACCOUNTS,
          "You do not have permission to create accounts."
        )
      ) {
        return;
      }
      this.showingAdd = true;
    },

    CloseaddNurse() {
      this.showingAdd = false;
      // Refresh the users table after create/close so new Pending rows appear.
      this.getAllAccountusers();
    },
    CreatePatient() {
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Registering your information..."),
        }
      );
      // this.form.isLoggedIn = this.isLoggedIn
      // this.form.admin = false
      // this.form.externid2 = this.allData.patient.externId2
      // register(this.form).then((data) => {

      // })
      post({ message: RequestRegistration })
        .then(() => {
          this.form.isLoggedIn = this.isLoggedIn;
          this.form.admin = false;
          this.form.externid2 = this.allData.patient.externId2;
          register(this.form).then((data) => {
            console.log(data)
          })
        })
        .then((res) => {
          console.log(res);
          alert(`Registration successful. The username is ${this.form.login}.`);
          post({ message: RegistrationSuccess });
        })
        .catch((err) => {
          post({ message: RegistrationFailure });
          alert("Registration failure: " + err);
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });
    },
    async addNewAccountUser() {
      let isaid="";
      let hvcertificate="";
      let certnum="";
      if (this.form.accountType === "Patient") {
        // this.CreatePatient();    
        // return;
        this.form.admin = false
      }
      if(this.form.accountType === "Home Health Aid")
      {
        //set or grab information that needs to be sent over to the server for processing 
        hvcertificate = this.form.hascertificate;
        certnum = this.form.certificateValue
        isaid = this.form.accountType;
      }
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: () => h("div", {}, `Creating account...`),
        }
      );
      //this.nwform.accountnumber= Math.floor(Math.random() * (899999999)) + 100000000;

      this.nwform.cell = this.form.primaryPhone; //$("#regphone").val();
      //this.nwform.accountnumber= Math.floor(Math.random() * (899999999)) + 100000000;//Okay I don't need this anymore because I Should be able to grab this from App State
      this.nwform.accountnumber = this.allData.patient.externId2;
      this.nwform.accountrole = this.form.permission; // "Administrator";
      this.nwform.Firstname = this.form.first;
      this.nwform.Lastname = this.form.last;
      this.nwform.Address = this.form.addr;
      this.nwform.prCity = this.form.city;
      this.nwform.prState = this.form.state;
      this.nwform.prZip = this.form.zip;
      this.nwform.accountType = this.form.accountType;
      if(this.nwform.accountType=="Home Health Aid")
      {
        this.nwform.isHHAid = isaid;
        this.nwform.aidHasCertificate = hvcertificate;
        this.nwform.aidCerticateValue = certnum;
      }
      this.nwform.commpref = this.form.pref;
      this.nwform.license = this.form.licenseNum;
      this.nwform.practicestate = this.form.licenseSt;
      this.nwform.dob = this.form.dob;
      this.nwform.gender = this.form.gender;
      this.nwform.username = this.form.login;
      this.nwform.password = this.form.password;
      this.nwform.email = this.form.email;
      // this.nwform.premission = this.form.premission;
      // this.nwform.externalid2 = this.allData.patient.externId2;//this.form.externid;
      this.nwform.uniqueNineID = this.form.externid;

      this.form.externid2 = this.nwform.accountnumber;
      console.log(this.form);

      register(this.form)
        .then((data) => {
          if (data.externid && data.externid != "") {
            //lets add the unique ID to the nwform here
            this.nwform.id = data.userId != null && data.userId !== "" ? data.userId : data.externid;
            let crtAcnt = this.SendAccountInfo().then((x) => {
              this.getAllAccountusers();
              loader.hide();
              this.$swal({
                type: "success",
                title: "Success",
                text:
                  "This account has been created. It must now be verified before it can be used.",
              });
              this.showingAdd = false
            });
          } else {
            alert("Something wrong with register function");
            console.log(data);
            loader.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Caught exception for register function");
        });
    },
    validateName(nameType) {
      //TODO: only letters are allowed at the moment
      const nameRegex = new RegExp("^([a-zA-Z])+([ a-zA-Z])*$");
      let error = null;

      this.form[nameType] = this.form[nameType].trim();
      this.formErrors[nameType] = [];
      if (this.form[nameType] !== "" && !nameRegex.test(this.form[nameType])) {
        error = VALIDATION_ERRORS.LETTERS_ONLY;
        // this.$set(this.formErrors[nameType], this.formErrors[nameType].length, error);
        this.formErrors[nameType][this.formErrors[nameType].length] = error
      }
    },
    validateUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");
      let error = null;

      this.form.login = this.form.login.trim();
      this.formErrors.login = [];
      //TODO: send ajax to check if username exist?
      if (!usernameRegex.test(this.form.login)) {
        error = VALIDATION_ERRORS.USERNAME_CHARACTERS;
        // this.$set(this.formErrors.login, this.formErrors.login.length, error);
        this.formErrors.login[this.formErrors.login.length] = error
      }
      if (this.form.login.length < 8 || this.form.login.length > 24) {
        error = VALIDATION_ERRORS.USERNAME_LENGTH;
        // this.$set(this.formErrors.login, this.formErrors.login.length, error);
        this.formErrors.login[this.formErrors.login.length] = error
      }
      if (this.formErrors.login.length < 1) {
        isUserExist(this.form.login)
          .then((userExists) => {
            // Assign (don't push) so overlapping isUserExist replies can't stack the same message.
            this.formErrors.login = userExists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
          })
          .catch((err) => {
            alert(err);
          });
      }
      return true;
    },
    validateEmail() {
      let error = null;
      isEmailExist(this.form.email)
        .then((exists) => {
          if (exists) {
            error = VALIDATION_ERRORS.EMAIL_EXISTS;
            // this.$set(this.formErrors.email, this.formErrors.email.length, error);
            this.formErrors.email[this.formErrors.email.length] = error
          } else {
            this.formErrors.email = [];
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    // `validatePerm` was removed with the sessionless surface. It called
    // `isPermExist` with an account *role* rather than an identifier, and
    // pacmny-be never implemented the action behind it — so it checked nothing,
    // and nothing on this form ever called it.
    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },

    randomId() {
      return Math.floor(Math.random() * 899999999) + 100000000;
    },
    async showNPIResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: $("#AccntFname") > val() + $("#AccntLname").val(),
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
          } else this.searchedNpis = res.data;
        });
      // this.stopPreloader()
    },
    async SendAccountInfo() {
      //now lets send over values to be saved on the serv er
      let formdata = new FormData()
      formdata.append("API_Meth", "CreateSubAccount")
      // nwform carries no upload URL any more (sendFile stores file_uid), so
      // nothing path-shaped is forwarded to CreateSubAccount.
      Object.keys(this.nwform).forEach((key) => {
        formdata.append(key, this.nwform[key])
      })
      // let content = {
      //   Account: {
      //     API_Meth: "CreateSubAccount",
      //     Formdata: this.nwform,
      //   },
      // };
      await axios
        .post(CURR_API + "/tswebhook.php", formdata, {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Account Created Successfully") {
            alert("SubAccount Created successfully");
            this.getAllAccountusers();
            //now run the email notification to bth the admin and the user
            this.SendSubAccountEmail();
            //return msg;
          } else if (res.data.message == "License Already Assigned") {
            alert(res.data.error);
          } else {
            //I would process error from the API here that are inline with the Account Setup on the backend
            console.log(res.data);
            alert("Account Not Created Successfully");
          }
        })
        .catch((err) => {
          console.log(err);
          let jdata = JSON.parse(err);
          alert(jdata); //spit out the error
          alert("Error" + " " + err.data);
          console.log("Error" + " " + jdata);
          msg = "Error with the Promise";
          return msg;
        });
    },
    async UpdateNewUser() {
      let content = {
        ManageNurseList: {
          API_Meth: "InternalAddNurse",
          ncsid: $("#nrnsbid").val(),
          jurisdiction: $("#nrstate").val(),
          subactioncode: "A", //required
          licensnum: $("#nrlicense").val(),
          ltype: $("#nursetype").val(),
          email: $("#nurseemail").val(),
          primearyphone: $("#primephone").val(),
          secondaryphone: $("#secphone").val(),
          address1: $("#nraddress").val(), //req
          address2: "",
          city: $("#nrcity").val(), //req
          state: $("#nrstate").val(), //req
          zip: $("#nrzip").val(), //req
          lastfourssn: $("#nrsocial").val(), //req
          bdayear: $("#nrdob").val(), //req
          hospitalpracsetting: "21", //req
          hostpracsettingother: "",
          notficationenabled: "Y", //req
          reminderenabled: "Y", //req
          locationlist: "",
          recid: "",
          accountnumber: $("#nraccount").val(),
          firstname: $("#nursefname").val(),
          lastname: $("#nurselname").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Inserted") {
            alert("Nurse Added to the system successfully!");
            //now close SMS Canvas
          } else if (res.data.message == "Record Exist") {
            alert(
              $("#nursefname").val() +
                " " +
                $("#nurselname").val() +
                ", already Exist in our System. You may want to edit or update Nurses Information from the Nurses section."
            );
          } else {
            alert(res.message);
            console.log("Nurses not added successfully");
          }
        });
    },

    ShowGroupList(index) {
      if ($("#accordionbottom" + index).css("display") == "block") {
        $("#accordionbottom" + index).slideUp("slow");
      } else {
        //close the Add Group Section

        $("#accordionbottom" + index).slideDown("slow");
      }
    },
    async loadAccountUsers() {
      let content = {
        Account: {
          API_Meth: "GetAccountUsers",
          accountnumber: "45000",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data) {
            this.allProvs = res.data.nurseInfo;
          } else {
            this.allProvs = null;
          }
        });
    },

    async SendSubAccountEmail() {
      let mcontent = {
        Account: {
          API_Meth: "SendNewSubAccountEmail", ///Api Method to call
          accountnumber: this.allData.patient.externId2, //account number
          uniquenine: this.nwform.uniqueNineID, //user unique nine
          accounttype: this.form.accountType,
          accountholder: this.form.first + " " + this.form.last,
          usertoemail: this.form.email,
          firstname: this.form.first,
          lastname: this.form.last,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", mcontent, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          console.log(res.data);
          console.log(res.data.status);

          if (res.data.status && res.data.status == "Successfull") {
            alert(
              "Account Email Notifcation has been Successfully Sent to both Administrator and the User."
            );
            //now hide the UI
          }
        })
        .catch((err) => {
          alert(err);
          console.log(err);
        });
    },

    async showResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: this.npiSearch,
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
            alert("No Search Results Found");
          } else {
            this.searchedNpis = res.data;
          }
        })
        .catch((err) => {
          alert(err);
          console.log(err);
        });
      // this.stopPreloader()
    },

    showAddProv() {
      if ($(".nurseSettingSec").css("display") == "block") {
        $(".nurseSettingSec").slideUp("slow");
        $(".result-list").slideDown("slow");
      } else {
        if ($("#nurseform").css("display") == "block") {
          $("#nurseform").slideUp("slow");
        }
        $(".result-list").slideUp("slow");
        $(".nurseSettingSec").slideDown("slow");
        //hide nurses cards
      }
    },

    selectNpi(npi, index) {
      /* console.log(npi.addresses[index].address);
           console.log(npi.addresses[index].address);
            let splitaddr = npi.addresses[index].address;
            let splitaddr2 = splitaddr.split(",");
            console.log(splitaddr2);
            let finaladdr = splitaddr2[0];
            let finalcity = splitaddr2[1];
            let finalstate = splitaddr2[2];
            let finalzip = splitaddr2[3];
            $("#AccntAddress").val(finaladdr);
            $("#AccntAddress").text(finaladdr);*/
      $("#AccntNpilicense").val(npi.npinumber);
      let name = npi.name.trim().split(" ");
      console.log(name[0]);
      console.log(name[1]);
      let entirename = $("#AccntFname").val();
      console.log(entirename);
      let nwname = entirename.split(" ");
      console.log(nwname);
      this.searchedNpis = nwname[0];
      $("#AccntLname").val("");
      $("#AccntFname").text("");
      $("#AccntFname").attr("value", nwname[0]);
      $("#AccntLname").attr("value", nwname[1]);
      $("#AccntFname").text(nwname[0]);
      $("#AccntLname").text(nwname[1]);
      $("#AccntFname").val(nwname[0]);
      $("#AccntLname").val(nwname[1]);
      console.log($("#AccntFname").text() + " " + $("#AccntLname").text());

      this.searchedNpis = null;
      this.searchedAddresses = npi.addresses;
    },
    async saveProv() {
      let callnumexist = "";
      let isemailValid = "";
      if ($("#phytel").val() != "" || $("#phycell").val() != "") {
        callnumexist = "true";
      } else {
        callnumexist = "false";
      }
      //valdate email
      let re = /^\w+([-+.'][^\s]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

      let emailFormat = re.test($("#phyemail").val()); // This return result in Boolean type
      console.log(emailFormat);
      if (emailFormat) {
        isemailValid = true;
      } else {
        isemailValid = false;
      }
      if (
        $("#phyfirstname").length != 0 &&
        $("#phylastname").length != 0 &&
        $("#phytel").length != 0 &&
        $("#phyemail").length != 0 &&
        isemailValid == true &&
        callnumexist == "true"
      ) {
        let form = document.getElementById("provform" + this.patient.id);
        let modal = document.getElementById("provmodal" + this.patient.id);
        let content = {
          Provider: {
            API_Meth: "AddProvider",
            provFname: form.elements["phyfirstname"].value,
            provLname: form.elements["phylastname"].value,
            provAddr1: form.elements["phyaddr"].value,
            provAddr2: "",
            provCity: "",
            provState: "",
            provZip: "",
            provTel: form.elements["phytel"].value,
            provCell: form.elements["phycell"].value,
            provFax: form.elements["phyfax"].value,
            npinumber: form.elements["phynpi"].value,
            pid: this.patient.externId,
            ordernumber: "999",
            status: "Active",
            provEmail: form.elements["phyemail"].value,
          },
        };
        console.log(content);
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.message && res.data.message == "Inserted") {
              this.npiSearch = null;
              this.searchedNpis = null;
              this.searchedAddresses = null;
              this.loadProviders();

              alert("Provider successfully added");
              form.reset();
              modal.style.display = "none";
            } else {
              alert(
                "Error with provider insertion. Try again or contact an administrator."
              );
            }
          });
      } else {
        alert(
          "Please ensure the form field requirements has been met. Please check your entries and try again."
        );
      }
    },
    async saveEditProv() {
      let form = document.getElementById("edit-prov-form-" + this.patient.id);
      let modal = document.getElementById("edit-prov-modal-" + this.patient.id);
      let content = {
        Provider: {
          API_Meth: "UpdateProvider",
          providerid: this.editedProv.providerid,
          email: "",
          patientid: this.patient.externId,
          ordernumber: "",
          firstname: form.elements["phyfirstname"].value,
          lastname: form.elements["phylastname"].value,
          address1: form.elements["phyaddr"].value,
          address2: "",
          city: "",
          state: "",
          zip: "",
          phone: form.elements["phytel"].value,
          cell: form.elements["phycell"].value,
          email: form.elements["phyemail"].value,
          fax: form.elements["phyfax"].value,
          npinumber: form.elements["phynpi"].value,
          status: "Active",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.msg && res.data.msg == "Updated") {
            this.loadProviders();
            alert("Provider successfully edited");
            this.editedProv = null;
            // form.style.display = "none"
            // modal.style.display = "none"
          } else {
            alert(res.data[1]);
          }
        });
    },
    selectAddr(addr, index) {
      console.log(addr.address);
      let naddr = addr.address.split(",");
      console.log(naddr);
      // document.querySelector("#AccntAddress").value =naddr[0];
      alert(naddr[0]);
      $("#AccntAddress").val(naddr[0]);
      document.querySelector("#AccntAddress").value = naddr[0];
      let splitcity = naddr[1].split(" ");
      console.log(splitcity);
      $("#AccntCity").val(splitcity[0]);
      $("#AccntState").val(splitcity[1]);
      $("#AccntZip").val(splitcity[2]);
      document.querySelector("#regphone").value = addr.tel ? addr.tel : "";
      //document.querySelector("#phyfax").value = addr.fax ? addr.fax : ""
      this.searchedAddresses = null;
    },
    closeProv() {
      let form = document.getElementById("provform" + this.patient.id);
      form.reset();
      this.npiSearch = null;
      this.searchedAddresses = null;
      this.searchedNpis = null;
      let modal = document.getElementById("provmodal" + this.patient.id);
      modal.style.display = "none";
    },
    closeEditProv() {
      let form = document.getElementById("edit-prov-form-" + this.patient.id);
      form.reset();
      this.npiSearch = null;
      this.searchedAddresses = null;
      this.searchedNpis = null;
      this.editedProv = null;
      let modal = document.getElementById("edit-prov-modal-" + this.patient.id);
      modal.style.display = "none";
    },
    closeNewProv() {
      let form = document.getElementById("accform" + this.patient.id);
      form.reset();
      this.addedProv = null;
    },
  },
};
</script>

<!-- Unscoped: #dtTable's rows/cells are injected by jQuery DataTables, not
     compiled by Vue's template compiler, so they never receive this
     component's scoped data-v attribute and scoped rules can't reach them. -->
<style lang="scss">
.linked-account-row {
  background-color: #eef3fb !important;
}

.linked-roles-badge {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #dbe7fb;
  color: #17469e;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
}

.linked-roles-none {
  color: #9aa5b1;
}

.account-status-pending-link {
  color: #0060ff;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.account-status-pending-link:hover {
  color: #004ecc;
}

.patient-invite-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  padding: 1rem;
}

.patient-invite-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  padding: 1.5rem 1.75rem;
  max-width: 480px;
  width: 100%;
}

.patient-invite-modal__name {
  margin: 0 0 0.35rem;
  font-weight: 600;
  color: #222;
}

.patient-invite-modal__email {
  margin: 0 0 1.25rem;
  color: #555;
  word-break: break-word;
}

.patient-invite-modal__email-label {
  display: block;
  margin: 0 0 0.35rem;
  font-size: 0.875rem;
  color: #444;
}

.patient-invite-modal__email-input {
  margin-bottom: 0.5rem;
}

.patient-invite-modal__email-error {
  margin: 0 0 0.75rem;
  color: #b00020;
  font-size: 0.875rem;
}

.patient-invite-modal__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.dgridlink-userid {
  display: inline-block;
  vertical-align: middle;
}

.user-id-reveal-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 1rem;
  font-weight: 600;
  color: #17469e;
}
</style>

<style scoped lang="scss">
// .form-group {
//   margin-bottom: 20px;
//   width: 100%;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 5px;
//   font-weight: 600;
//   font-size: 14px;
// }
.container {
  overflow-x: auto;
}
.um-modcontainer {
  display: flex;
  text-align: center;
}
.um-submenu.container {
  max-width: 250px;
  /*background-color: #fff;*/
  margin: 0px 20px;
  height: auto;
  /* padding-bottom: 5px;*/
  z-index: 1000;
}
.um-submenu {
  display: none;
}
.um-submenu.container:hover {
  display: block;
}
.createNewUserSec {
  display: flex;
  flex-direction: row-reverse;
}
.new-user-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: none;
  justify-content: center;
  align-items: center;
}

.npinamemodal {
  z-index: 20000;
}
#createNwUserbtn {
  margin-right: 30px;
  height: 55px;
  background-color: #f0a10f;
  color: #fff;
  font-weight: 600;
}
.nursefield-container {
  display: none; //needs to be flex on Aaccount type
  flex-direction: horizontal;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.npi-container {
  display: none; //needs to be flex if the account type is changed to Provider
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.edit-prov-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.nurseform-btn {
  display: flex;
  align-items: space-evenly;
}
#nurseform {
  display: none;
}
#nurseform .msgbx {
  display: none;
  background-color: red;
  color: #fff;
  font-size: 18px;
  padding: 10px;
  margin-bottom: 10px;
  word-break: break-word;
}
.top-title {
  text-align: center;
  color: #0060ff;
  margin-top: 1.75rem;
  margin-bottom: 1rem;
}

.new-acc-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.send-text-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-acc-modal form {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 50%;
  width: 100%;
}

.new-prov-modal form {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.inner-text-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

// .form-group {
//   margin-bottom: 20px;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 5px;
//   font-weight: 600;
//   font-size: 14px;
// }

// .form-control {
//   display: block;
//   width: 100%;
//   height: 40px;
//   padding: 10px;
//   font-size: 16px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   box-shadow: none;
// }

.btn-group {
  display: flex;
  justify-content: flex-end;
}
// .form-control.prvtxtMsgbox {
//   border-style: solid;
//   border-color: #000000;
//   height: 140px;
// }
.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}

.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
}

.title {
  margin-right: 20px;
}

.result-list {
  width: 700px;
}

.result-item {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto 0;
  text-align: left;
}

.result-item:first-child {
  margin-top: 1em;
}

.header3 {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}

.capitalize {
  text-transform: capitalize;
}

.result-item-link {
  display: block;
  text-align: right;
  font-size: 0.85em;
}

ul {
  list-style-type: none;
  margin: 0 auto;
}
.providerGroup-listcard {
  display: flex;
  justify-content: space-evenly;
  border-style: dashed;
  border-width: 1px;
  width: 100%;
}
/*Keyon Add Provider CSS*/
#nurseform .form-container {
  display: flex;
  flex-direction: column;
  max-width: 700px;
}
// .form-container input {
//   margin-bottom: 10px;
// }
// .form-container select {
//   width: 95%;
//   height: 42px;
// }

#nursetype {
  margin-bottom: 10px;
}
.provcardSec {
  display: none;
  align-items: center;
  position: relative;
  flex-direction: column;
}
.emailcanvas {
  display: none;
}

#cllprov {
  margin-left: 20px;
}
#providetomail {
  margin-left: 30px;
}
#provemailsubject {
  margin-left: 30px;
}
#provid-emailmsg {
  margin-left: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
  width: 400px;
  height: 100px;
}
#sendprovid-emailbtn {
  margin-left: 30px;
}
.emailcanvas .container {
  box-shadow: 1px 1px 9px #5f5852;
  position: absolute;
  background-color: #ffffff;
  width: 855px;
  height: auto; // 710px;
  padding-bottom: 20px;
  margin: 0 auto;
}
.emailcanvas .btn-container {
  padding-bottom: 30px;
}
.emailcanvas label {
  margin-bottom: 20px;
}
#providetomail {
  margin-left: 30px;
}
.emailcanvas ul {
  display: flex;
  margin-top: -64px;
}
.emailcanvas .emailli {
  list-style: none;
  margin-left: 20px;
}
.emailcanvas .emailblock {
  background-color: #aaabac;
  padding: 5px 5px;
  width: auto;
  height: auto;
  margin-left: 12px;
  position: relative;
  top: 17px;
}
.emailcanvas .xout {
  background-color: white;
  cursor: pointer;
}
.mmailbox {
  background-color: #55555512;
  width: 100%;
  position: relative;
  z-index: 3000000000;
  top: -35px;
}
.mmailbox #hiddenmail {
  display: none;
}
.emailcanvas .selectbox {
  margin-top: -10px;
}
.inputvalholder {
  display: none;
  justify-content: flex-start;
}
.listGroupSec {
  display: none;
}
.listGroupSec .card .accordhead {
  display: flex;
  flex-direction: row-reverse;
  border-style: solid;
  border-width: 1px;
  border-color: #606565b0;
}
.listGroupSec .card .caret {
  text-align: right;
  width: 100px;
}
.listGroupSec .card .grp-name {
  width: 100%;
  margin: 0 auto;
}
.listGroupSec .card .grp-name p {
  text-align: center;
}
.listGroupSec .accordionbottom {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-style: solid;
  border-width: 1px;
  border-color: #0433;
  display: flex;
}
.listGroupSec .providminicard {
  display: flex;
  flex-direction: row-reverse;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  flex-direction: row-reverse;
  padding: 11px;
  margin-bottom: 3px;
}
.listGroupSec #accord-caret {
  cursor: pointer;
}
.listGroupSec #accord-caret:hover {
  color: #4553;
}
.listGroupSec .groupcanvas .card {
  display: flex;
  flex-direction: column;
}
.listGroupSec .subnavcontainer {
  display: none;
  flex-direction: column;
  width: 248px;
  margin-left: -153px;
  border-style: ridge;
  padding: 11px;
}
.listGroupSec #elipse {
  cursor: pointer;
}
.listGroupSec .closecanvas {
  display: none;
}
.listGroupSec .creategrpcanvas {
  display: none;
}
.listGroupSec .groupcanvas {
  display: none;
}
.accordionbottom {
  display: none;
}
.smsconferencecanvas {
  display: none;
}
.listGroupSec .accordionbottom {
  display: none;
}
.groupemailcecanvas {
  display: none;
}
#sbmttxtconfbtn {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
}
#smsconferencebox {
  width: 650px;
  height: 220px;
}
#smsconferencephone {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}
.smsconferencecanvas .container {
  padding: 10px;
  display: flex;
  text-align: center;
}
.groupemailcecanvas .container {
  padding: 10px 100px;
  display: flex;
  text-align: center;
}
#emailform {
  border-style: solid;
  border-width: 1px;
  border-color: #003330;
}
#conferenceEmail {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}
#emailconferencebox {
  width: 650px;
  height: 220px;
}
#sbmtemailconfbtn {
  margin-top: 15px;
  margin-bottom: 15px;
}
.smsconferencecanvas #closeconfcallbtn {
  margin-left: 15px;
}
#groupemailcancelbtn {
  margin-left: 15px;
}
.prvtxtbox {
  height: 42px;
}
.status-active {
  display: none;
  background-color: #70a50d;
  color: #ffffff;
  font-size: 17px;
}
.status-nonactive {
  display: none;
  background-color: #f12f4f;
  color: #ffffff;
  font-size: 17px;
}
// .form-container {
//   display: flex;
//   flex-wrap: wrap;
//   padding: 0px 20%;
// }
// .form-container input {
//   width: 95%;
//   height: 45px;
// }
.nurseSettingSec {
  width: 100%;
  height: auto;
  display: none;
}
.nurseSettingSec form {
  display: flex;

  align-items: left;
  flex-direction: column;
}
.nurseSettingSec .horizontal {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: start;
}
.nurseSettingSec .vertical {
  display: flex;
  flex-direction: column;
}
.h-vertical {
  display: flex;
  flex-direction: column;
}
.setting-container {
  max-width: 700px;
}
#savesettingbtn {
  margin-right: 20px;
}
.nurseSettingSec select {
  margin-left: 20px;
  margin-bottom: 20px;
  width: 265px;
  border-radius: 6px;
  height: 32.5px;
}
/*End Keyon Provider CSS*/
@media only screen and (min-width: 1024px) {
}
@media only screen and (min-width: 1024px) {
  #provid-emailmsg {
    width: 400px;
  }
  .result-list .emailcanvas .container {
    width: 655px;
  }
  .groupemailcecanvas .container {
    padding: 10px 100px;
  }
  #conferenceEmail {
    margin: 20px;
  }
  #emailconferencebox {
    width: 100%;
  }
  .icon .desktopTel {
    display: flex;
  }
  .icon .mobileTel {
    display: none;
  }
  .emailcanvas .container textarea {
    width: 485px;
    height: 175px;
  }
  #smsconferencebox {
    width: 650px;
  }
  #smsconferencephone {
    width: 425px;
    margin: 20px;
  }
}
@media only screen and (max-width: 768px) {
  .result-list {
    width: 100%;
  }
}
@media only screen and (min-width: 360px) {
  #smsconferencephone {
    width: 100%;
    margin: 0px;
  }
  #smsconferencebox {
    width: 100%;
  }
  .d-option {
    display: none;
  }
  .icon .desktopTel {
    display: none;
  }
  .icon .mobileTel {
    display: flex;
  }
  #provid-emailmsg {
    width: 280px;
  }
  .emailcanvas .container {
    width: 340px;
  }
  .groupemailcecanvas .container {
    padding: 0px;
  }
  #conferenceEmail {
    margin: 10px 0px;
    width: 100%;
  }
  #emailconferencebox {
    width: 100%;
  }
}
@media only screen and (max-width: 576px) {
  .new-acc-modal form {
    max-width: unset;
  }
  #subaccountform {
    overflow-y: scroll;
    height: 100%;
  }
}

/* Mobile-specific z-index adjustments for mobile message widget */
@media (max-width: 768px) {
  .mmailbox {
    z-index: 1 !important;
  }
  
  /* Override all high z-index elements to stay below mobile widget */
  [style*="z-index"] {
    z-index: 1 !important;
  }
  
  /* Specific overrides for known high z-index elements */
  .modal-overlay,
  .modal-content,
  .popup-container {
    z-index: 1 !important;
  }
}
</style>
